/** Build GraphQL cart mutation item payloads with backward-compatible shapes. */

export const buildCartAddItemInput = (item) => {
  const itemInput = {
    productId: item?.itemId ? item.itemId : item?.productId,
    quantity: item?.quantity,
    skuId: item?.skuId,
  };

  if (item?.isOfferItem === true) {
    itemInput.isOfferItem = true;
    if (item?.offerId != null && item?.offerId !== '') {
      itemInput.offerId = item.offerId;
    }
  }

  return itemInput;
};

export const buildCartRemoveItemInput = (item) => {
  const itemPayload = {
    productId: item?.itemId ? item.itemId : item?.productId,
    quantity: item?.quantity,
    skuId: item?.skuId,
  };

  if (item?.isOfferItem === true) {
    itemPayload.isOfferItem = true;
    if (item?.offerId != null && item?.offerId !== '') {
      itemPayload.offerId = item.offerId;
    }
  }

  return itemPayload;
};

export const shouldBlockOfferIncrement = (item, nextQuantity) => {
  const maxOfferQty = item?.maxOfferQty ?? item?.maxQty;
  const isOfferLine = item?.isOfferItem === true;
  if (!isOfferLine || maxOfferQty == null || maxOfferQty === '') {
    return false;
  }
  const maxQty = Number(maxOfferQty);
  if (!Number.isFinite(maxQty)) {
    return false;
  }
  return Number(nextQuantity) > maxQty;
};
